import React, {useState} from 'react';
import {motion} from "framer-motion";
import s from "../KycPersonalStepTwo/KycPersonalStepTwo.module.css";
import CustomModal from "../../../../../../components/ui/CustomModal/CustomModal";
import MyBtn from "../../../../../../components/ui/MyBtn/MyBtn";
import {Field, Formik} from "formik";
import {editKycThunk, setTokenState} from "../../../../../../store/reducers/ActionCreators";
import {Checkbox, Popover} from "antd";
import info from "../../../../../../assets/newImg/personalAccount/information.svg";
import MyInput from "../../../../../../components/ui/MyInput/MyInput";
import CustomDropdown from "../../../../../../components/ui/CustomDropdown/CustomDropdown";
import classnames from "classnames";
import CustomCheckbox from "../../../../../../components/ui/customCheckbox/CustomCheckbox";
import passportSpread from "../../../../../../assets/newImg/personalAccount/passport_spread.png";
import selfi from "../../../../../../assets/newImg/personalAccount/selfi.png";
import proof from "../../../../../../assets/newImg/personalAccount/proof.png";
import {ReactComponent as Back}  from "../../../../../../assets/newImg/personalAccount/back.svg";
import {useAppDispatch, useAppSelector} from "../../../../../../hooks/redux";
import Icon from "@ant-design/icons";
import TransparentButton from "../../../../../../components/ui/TransparentButton/TransparentButton";
import {countries} from "../../../../../../Constants/StaticData";
import {setDisabled} from "../../../../../../store/reducers/UserSlice";
import SelectWithSearch from "../../../../../../components/ui/SelectWithSearch/SelectWithSearch";
import FileInput from '../../../../../../components/FileInput/FileInput';
import { getPhoneNumberList } from '../../../../../../Constants/KycConstants';

const EditKycPersonal = (props: any) => {

    const token: string = useAppSelector(state => state.userReducer.user.userToken)
    const newKycList = useAppSelector(state => state.userReducer.user.kycList)
    const dispatch = useAppDispatch()

    // @ts-ignore
    const phoneNumber = newKycList[0].phoneNumber

    // @ts-ignore
    console.log(newKycList[0].isOtherSourcesOfWealth)

    const [documents, setDocuments] = useState<any>(
        {
            passportSpread: '',
            selfie: '',
            proofOfAddress: '',
        }
    )

    const [docsError, setDocsError] = useState(false)
    const [isPep, setIsPep] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Something went wrong. Please try again later.");
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

    const phoneList = useAppSelector(
        (state) => state.userReducer.user.phoneList
    );

    const closeAndRedirect = () => {
        setIsModalOpen(false)
        props.setCurrent(0)
    }

    function toBase64(file: any) {
        if (!file) {
            return
        }
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    const sourcesOfWealthHandlerChange = (e: any, meta: any, form: any, name: string) => {
        form.setFieldValue("otherSourcesOfWealth", '');
        form.setFieldValue("isOtherSourcesOfWealth", false);
        const {checked} = e.target;
        if (checked) {
            form.setFieldValue("sourcesOfWealth", [...meta.value.sourcesOfWealth, name]);
        } else {
            const filteredArr = meta.value.sourcesOfWealth.filter((i: string) => i !== name)
            form.setFieldValue("sourcesOfWealth", filteredArr);
        }
    }

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >
            <div className={s.wrapper}>

                <CustomModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}>
                    <div className={s.flex}>
                        <div className={s.modal_title}>
                            Success!
                        </div>
                        <div className={s.modal_subtitle}>
                            Your details will be sent for review.
                        </div>
                        <div className={s.button_block}>
                            <MyBtn title={"Ok"} onClick={() => closeAndRedirect()}/>
                        </div>
                    </div>
                </CustomModal>
                <CustomModal type="error" isModalOpen={isErrorModalOpen} setIsModalOpen={setIsErrorModalOpen}>
                    <div className={s.flex}>
                        <div className={s.modal_title}>
                            Oops!
                        </div>
                        <div className={s.modal_subtitle}>
                            {errorMessage}
                        </div>
                        <div className={s.button_block}>
                            <MyBtn buttonType="error" title={"Ok"} onClick={() => setIsErrorModalOpen(false)}/>
                        </div>
                    </div>
                </CustomModal>

                <div className={s.page_title}>
                    KYC for Personal Accounts
                </div>

                <Formik
                    initialValues={{
                        // @ts-ignore
                        firstName: newKycList[0].firstName,
                        // @ts-ignore
                        lastName: newKycList[0].lastName,
                        // @ts-ignore
                        kycId: newKycList[0]?.id,
                        // @ts-ignore
                        country: newKycList[0].country,
                        // @ts-ignore
                        phoneNumber: phoneNumber,
                        // @ts-ignore
                        sourcesOfWealth: newKycList[0].sourcesOfWealth,
                        // @ts-ignore
                        isOtherSourcesOfWealth: newKycList[0].isOtherSourcesOfWealth,
                        // @ts-ignore
                        otherSourcesOfWealth: newKycList[0].isOtherSourcesOfWealth ? newKycList[0].sourcesOfWealth[0] : '',
                        // @ts-ignore
                        currencies: newKycList[0].currencies,
                        pep: false,
                        files: {
                            passportSpread: '',
                            selfie: '',
                            proofOfAddress: '',
                        }
                    }}
                    onSubmit={async (values) => {
                        let tempData = {
                            ...values,
                            phoneNumber: values.phoneNumber,
                            pep: isPep,
                            files: {}
                        }

                        let convertedPassportSpread = await toBase64(documents.passportSpread) as string
                        let convertedProofOfAddress = await toBase64(documents.proofOfAddress) as string
                        let convertedSelfie = await toBase64(documents.selfie) as string


                        if (convertedPassportSpread) {
                            tempData.files = {
                                ...tempData.files,
                                passportSpread: convertedPassportSpread,
                            }
                        }


                        if (convertedProofOfAddress) {
                            tempData.files = {
                                ...tempData.files,
                                proofOfAddress: convertedProofOfAddress,
                            }
                        }


                        if (convertedSelfie) {
                            tempData.files = {
                                ...tempData.files,
                                selfie: convertedSelfie,
                            }
                        }

                        dispatch(editKycThunk(token, tempData))
                            .then((res) => {
                                if (res.data === "Updated") {
                                    setIsModalOpen(true)
                                }
                            })
                            .catch((error) => {
                                if (error.response.data === "Invalid authorization data") {
                                    dispatch(setTokenState(false))
                                    return
                                }

                                if (error.response.data === "Too many phones. Max count is 5") {
                                    setErrorMessage(error.response.data)
                                    setIsErrorModalOpen(true)
                                    return
                                }

                                if (error.response.data === "Phone already exist") {
                                    setErrorMessage("This phone number already exists. Please try another phone number.")
                                    setIsErrorModalOpen(true)
                                    return
                                }

                                if (error.code === "ERR_NETWORK" && !error.response) {
                                    setErrorMessage("Maximum files size is 17 MB")
                                    setIsErrorModalOpen(true)
                                } else {
                                    setErrorMessage("Something went wrong. Please try again later.")
                                    setIsErrorModalOpen(true)
                                }
                            })
                            .finally(() => {
                                dispatch(setDisabled(false))
                            })
                    }}
                >
                    {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit
                      }) => (
                        <form onSubmit={handleSubmit}>
                            <div className={s.row}>
                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        * First name
                                        <Popover content={"Enter your First Name as in the ID document."}
                                                 color={'#EEEFEF'}
                                                 overlayInnerStyle={{
                                                     fontFamily: 'Inter',
                                                     width: '280px',
                                                     padding: '13px 16px'
                                                 }}
                                        >
                                            <img src={info} alt=""/>
                                        </Popover>
                                    </div>
                                    <MyInput id='firstName'
                                             name='firstName'
                                             onChange={handleChange}
                                             value={values.firstName}
                                             isError={errors.firstName}
                                             touched={touched.firstName}
                                    />
                                </div>

                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        * Last name
                                        <Popover content={"Enter your Last Name as in the ID document."}
                                                 color={'#EEEFEF'}
                                                 overlayInnerStyle={{
                                                     fontFamily: 'Inter',
                                                     width: '280px',
                                                     padding: '13px 16px'
                                                 }}
                                        >
                                            <img src={info} alt=""/>
                                        </Popover>
                                    </div>
                                    <MyInput id='lastName'
                                             name='lastName'
                                             onChange={handleChange}
                                             value={values.lastName}
                                             isError={errors.lastName}
                                             touched={touched.lastName}
                                    />
                                </div>
                            </div>

                            <div className={s.row}>
                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        * Country
                                    </div>
                                    <SelectWithSearch
                                        id="country"
                                        name="country"
                                        isError={errors.country}
                                        items={countries}
                                    />
                                </div>

                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        * Phone number
                                    </div>
                                    <CustomDropdown
                                        items={getPhoneNumberList(phoneList)}
                                        placeholder={"Choose your phone number"}
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        isError={errors.phoneNumber}
                                        touched={touched.phoneNumber}
                                    />
                                </div>
                            </div>

                            <div className={s.row}>
                                <div className={classnames(s.input_block)}>
                                    <div className={s.input_label}>
                                        * Sources of wealth or income
                                    </div>
                                    <div role="group" aria-labelledby="checkbox-group"
                                         className={s.sources_of_wealth_wrapper}>
                                        <label className={s.checkbox_block}>
                                            <Field
                                                render={(props: any) => {
                                                    return (
                                                        <Checkbox
                                                            checked={props.meta.value.sourcesOfWealth.includes("Inheritances")}
                                                            onChange={(e) => {
                                                                sourcesOfWealthHandlerChange(e, props.meta, props.form, "Inheritances")
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                            <span className={s.checkbox_label}>Inheritances</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field
                                                render={(props: any) => {
                                                    return (
                                                        <Checkbox
                                                            checked={props.meta.value.sourcesOfWealth.includes("Investments")}
                                                            onChange={(e) => {
                                                                sourcesOfWealthHandlerChange(e, props.meta, props.form, "Investments")
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                            <span className={s.checkbox_label}>Investments</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field
                                                render={(props: any) => {
                                                    return (
                                                        <Checkbox
                                                            checked={props.meta.value.sourcesOfWealth.includes("Business ownership interests")}
                                                            onChange={(e) => {
                                                                sourcesOfWealthHandlerChange(e, props.meta, props.form, "Business ownership interests")
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                            <span className={s.checkbox_label}>Business ownership interests</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field
                                                render={(props: any) => {
                                                    return (
                                                        <Checkbox
                                                            checked={props.meta.value.sourcesOfWealth.includes("Employment income")}
                                                            onChange={(e) => {
                                                                sourcesOfWealthHandlerChange(e, props.meta, props.form, "Employment income")
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                            <span className={s.checkbox_label}>Employment income</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field
                                                render={(props: any) => {
                                                    return (
                                                        <Checkbox
                                                            checked={props.meta.value.sourcesOfWealth.includes("Personal savings")}
                                                            onChange={(e) => {
                                                                sourcesOfWealthHandlerChange(e, props.meta, props.form, "Personal savings")
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                            <span className={s.checkbox_label}>Personal savings</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field
                                                render={(props: any) => {
                                                    return (
                                                        <Checkbox
                                                            checked={props.meta.value.sourcesOfWealth.includes("Pension releases")}
                                                            onChange={(e) => {
                                                                sourcesOfWealthHandlerChange(e, props.meta, props.form, "Pension releases")
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                            <span className={s.checkbox_label}>Pension releases</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field
                                                render={(props: any) => {
                                                    return (
                                                        <Checkbox
                                                            checked={props.meta.value.sourcesOfWealth.includes("Share sales and dividends")}
                                                            onChange={(e) => {
                                                                sourcesOfWealthHandlerChange(e, props.meta, props.form, "Share sales and dividends")
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                            <span className={s.checkbox_label}>Share sales and dividends</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field
                                                render={(props: any) => {
                                                    return (
                                                        <Checkbox
                                                            checked={props.meta.value.sourcesOfWealth.includes("Property sales")}
                                                            onChange={(e) => {
                                                                sourcesOfWealthHandlerChange(e, props.meta, props.form, "Property sales")
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                            <span className={s.checkbox_label}>Property sales</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field
                                                render={(props: any) => {
                                                    return (
                                                        <Checkbox
                                                            checked={props.meta.value.sourcesOfWealth.includes("Gambling winnings")}
                                                            onChange={(e) => {
                                                                sourcesOfWealthHandlerChange(e, props.meta, props.form, "Gambling winnings")
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                            <span className={s.checkbox_label}>Gambling winnings</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field
                                                render={(props: any) => {
                                                    return (
                                                        <Checkbox
                                                            checked={props.meta.value.sourcesOfWealth.includes("Inheritances and gifts")}
                                                            onChange={(e) => {
                                                                sourcesOfWealthHandlerChange(e, props.meta, props.form, "Inheritances and gifts")
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                            <span className={s.checkbox_label}>Inheritances and gifts</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field
                                                render={(props: any) => {
                                                    return (
                                                        <Checkbox
                                                            checked={props.meta.value.sourcesOfWealth.includes("Compensation from legal rulings")}
                                                            onChange={(e) => {
                                                                sourcesOfWealthHandlerChange(e, props.meta, props.form, "Compensation from legal rulings")
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                            <span className={s.checkbox_label}>Compensation from legal rulings</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field
                                                render={(props: any) => {
                                                    return (
                                                        <Checkbox
                                                            // @ts-ignore
                                                            checked={values.isOtherSourcesOfWealth}
                                                            onChange={(e) => {
                                                                const {checked} = e.target;
                                                                if (checked) {
                                                                    props.form.setFieldValue("sourcesOfWealth", []);
                                                                }
                                                                props.form.setFieldValue(
                                                                    "isOtherSourcesOfWealth",
                                                                    checked
                                                                );
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                            <span className={s.checkbox_label}>Other</span>
                                        </label>
                                    </div>
                                    {errors.sourcesOfWealth && values.sourcesOfWealth.length === 0 &&
                                        <div className={s.error_message}>{errors.sourcesOfWealth}</div>}
                                </div>
                            </div>

                            <div className={s.row}>
                                {
                                    // @ts-ignore
                                    values.isOtherSourcesOfWealth &&
                                    <div className={s.input_block}>
                                        <div className={s.input_label}>
                                            * Other
                                        </div>
                                        <MyInput id='otherSourcesOfWealth'
                                                 name='otherSourcesOfWealth'
                                                 onChange={handleChange}
                                                 value={values.otherSourcesOfWealth}
                                                 isError={errors.otherSourcesOfWealth}
                                                 touched={touched.otherSourcesOfWealth}
                                        />
                                    </div>
                                }
                                <div className={s.input_block}>
                                </div>
                            </div>

                            <div className={s.row}>
                                <div className={classnames(s.input_block)}>
                                    <div className={classnames(s.input_label, errors.currencies && s.doc_error)}
                                         id="checkbox-group">
                                        * Add a new account
                                    </div>
                                    <div role="group" aria-labelledby="checkbox-group" className={s.checkbox_wrapper}>
                                        <label className={s.checkbox_block}>
                                            <Field as={Checkbox} type="checkbox" name="currencies" value="CAD"/>
                                            <span className={s.checkbox_label}>CAD</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field as={Checkbox} type="checkbox" name="currencies" value="EUR"/>
                                            <span className={s.checkbox_label}>EUR</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field as={Checkbox} type="checkbox" name="currencies" value="GBP"/>
                                            <span className={s.checkbox_label}>GBP</span>
                                        </label>
                                        <label className={s.checkbox_block}>
                                            <Field as={Checkbox} type="checkbox" name="currencies" value="USD"/>
                                            <span className={s.checkbox_label}>USD</span>
                                        </label>
                                    </div>
                                    {errors.currencies &&
                                        <div className={s.error_message}>{errors.currencies}</div>}
                                </div>
                            </div>

                            <div className={s.row}>
                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        * Politically exposed person (pep)
                                    </div>
                                    <div className={classnames(s.flex_label, s.radio_block)}>
                                        <label className={s.flex_label}>
                                            <CustomCheckbox
                                                handleChange={() => setIsPep(false)}
                                                id="No"
                                                name="No"
                                                isChecked={!isPep}
                                            />
                                            <span className={s.type_of_account}>No</span>
                                        </label>
                                        <label className={s.flex_label}>
                                            <CustomCheckbox
                                                handleChange={() => setIsPep(true)}
                                                id="Yes"
                                                name="Yes"
                                                isChecked={isPep}
                                            />
                                            <span className={s.type_of_account}>Yes</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className={s.line}></div>

                            <div className={s.add_doc_block}>
                                <div className={s.content_block}>
                                    <div>
                                        <img src={passportSpread} alt=""/>
                                    </div>
                                    <div>
                                        <div
                                            className={classnames(s.title, docsError && documents.passportSpread === '' && s.doc_error)}>
                                            <span className={s.required}>* </span>
                                            Passport spread with your photo
                                        </div>
                                        <div>
                                            <ul className={s.passport_spread_list}>
                                                <li>
                                        <span className={s.text_color}>
                                            A color photo contains full document in clear focus and the data can be read
                                            easily.
                                        </span>
                                                </li>
                                                <li>
                                        <span className={s.text_color}>
                                             There're no light glares impeding document readability.
                                        </span>
                                                </li>
                                                <li>
                                        <span className={s.text_color}>
                                            A photo was not edited in graphic applications (we will definitely check).
                                        </span>
                                                </li>
                                                <li>
                                        <span className={s.text_color}>
                                           Picture format: JPEG, JPG, PNG, GIF, HEIC, PDF.
                                        </span>
                                                </li>
                                                <li>
                                        <span className={s.text_color}>
                                            Minimum picture resolution: 800 x 600 pixels.
                                        </span>
                                                </li>
                                                <li>
                                        <span className={s.text_color}>
                                            Maximum file size: 8Mb.
                                        </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <FileInput
                                    s={s}
                                    documents={documents}
                                    kycList={newKycList}
                                    key={"passportSpread"}
                                    inputId={"passportSpread"}
                                    allowedTypes={[".png", ".jpg", ".jpeg", ".pdf", ".heic"]}
                                    identifier={"passportSpread"}
                                    maxFileSize={8}
                                    onChange={(event) => {
                                        setDocuments({
                                            ...documents,
                                                // @ts-ignore
                                                passportSpread: event.currentTarget.files[0]
                                        });
                                    }}
                                    onImageClick={() => {
                                        // @ts-ignore
                                        document.getElementById("passportSpread").value = ""
                                        setDocuments({...documents, passportSpread: ""})
                                    }}
                                />

                            </div>

                            <div className={s.line}></div>

                            <div className={s.add_doc_block}>
                                <div className={s.content_block}>
                                    <div>
                                        <img src={selfi} alt=""/>
                                    </div>
                                    <div>
                                        <div
                                            className={classnames(s.title, docsError && documents.selfie === '' && s.doc_error)}>
                                            <span className={s.required}>* </span>
                                            Selfie with your Passport
                                        </div>
                                        <div className={s.add_block_text}>
                                            Upload a selfie of the Account Holder holding his Passport (at the page with
                                            a
                                            photo) in
                                            one hand and a paper with written name of platform "Mondial", date
                                            (dd/mm/yyyy/) and
                                            Account Holder's signature in the other hand. Photo should be good enough so
                                            it
                                            is
                                            possible to read ID data and see written on the paper text. You can use help
                                            of
                                            another
                                            person to make this photo or use a delayed photo function on your phone.
                                        </div>
                                    </div>
                                </div>
                                <FileInput
                                    s={s}
                                    documents={documents}
                                    kycList={newKycList}
                                    key={"selfie"}
                                    inputId={"selfie"}
                                    allowedTypes={[".png", ".jpg", ".jpeg", ".pdf", ".heic"]}
                                    identifier={"selfie"}
                                    maxFileSize={8}
                                    onChange={(event) => {
                                        setDocuments({
                                            ...documents,
                                                // @ts-ignore
                                                selfie: event.currentTarget.files[0]
                                        });
                                    }}
                                    onImageClick={() => {
                                        // @ts-ignore
                                        document.getElementById("selfie").value = ""
                                        setDocuments({...documents, selfie: ""})
                                    }}
                                />

                            </div>

                            <div className={s.line}></div>

                            <div className={s.add_doc_block}>
                                <div className={s.content_block}>
                                    <div>
                                        <img src={proof} alt=""/>
                                    </div>
                                    <div>
                                        <div
                                            className={classnames(s.title, docsError && documents.proofOfAddress === '' && s.doc_error)}>
                                            <span className={s.required}>* </span>
                                            Personal Proof of Address
                                        </div>
                                        <div>
                                            <ul className={s.passport_spread_list}>
                                                <li>
                                        <span className={s.text_color}>
                                            Bank statement with the date of issue and the name of the person (the document
                                            must be not older than 3 months);
                                        </span>
                                                </li>
                                                <li>
                                        <span className={s.text_color}>
                                             Utility bill for gas, electricity, water, internet, etc. linked to the property
                                            (the document must not be older than 3 months).
                                        </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <FileInput
                                    s={s}
                                    documents={documents}
                                    kycList={newKycList}
                                    key={"proofOfAddress"}
                                    inputId={"proofOfAddress"}
                                    allowedTypes={[".png", ".jpg", ".jpeg", ".pdf", ".heic"]}
                                    identifier={"proofOfAddress"}
                                    maxFileSize={8}
                                    onChange={(event) => {
                                        setDocuments({
                                            ...documents,
                                                // @ts-ignore
                                                proofOfAddress: event.currentTarget.files[0]
                                        });
                                    }}
                                    onImageClick={() => {
                                        // @ts-ignore
                                        document.getElementById("proofOfAddress").value = ""
                                        setDocuments({...documents, proofOfAddress: ""})
                                    }}
                                />

                            </div>

                            <div className={s.line}></div>

                            <div className={s.btn_block}>
                                <div className={s.button_back_wrapper}>
                                    <TransparentButton
                                        icon={<Icon component={() => <Back/>} rev={undefined}/>}
                                        title={"Back"}
                                        onClick={() => props.setCurrent(0)}/>
                                </div>
                                <div className={s.button_apply_wrapper}>
                                    <MyBtn title={'Apply'} type={'submit'}/>
                                </div>
                            </div>

                        </form>
                    )}
                </Formik>


            </div>
        </motion.div>
    );
};

export default EditKycPersonal;
